class RequestQuoteForm extends window.ProfessionalsMainForm {
  static EMBED_ID = 'app-embed-container-1101863';

  static FORM_ID = '1101863';

  static STEPS = [
    {
      label: 'Initial Information',
      startsAt: 'field-first_name',
    },
    {
      label: 'Trade Application',
      startsAt: 'field-customer_fields#new_singleline_text_field_2',
    },
    {
      label: 'Project Information',
      startsAt: 'field-customer_fields#project_name',
    },
  ];

  static FULL_WIDTH_FIELDS = [
    'field-customer_fields#new_singleline_text_field_2',
    'field-customer_fields#business_id',
    'field-customer_fields#business_address',
    'field-customer_fields#business_address_2_optiona',
    'field-customer_fields#country',
    'field-custom#business_website',
    'field-customer_fields#project_name',
    'field-custom#shipping_address_zip_code_',
    'field-customer_fields#specifer',
    'field-customer_fields#dealerpurchaser',
  ];

  static UPLOAD_HELP = {
    items: [
      'A valid business license as an Interior Designer, Architect, or Commercial Developer.',
      'Valid membership to a major design organization (e.g. ASID, IIDA, NKBA, IDC).',
      'Interior Design certification (e.g. NCIDQ, CCIDC).',
    ],
    footnote: "Please add your resale license if you'd like to receive tax-free checkout.",
  };

  static SUCCESS = {
    heading: 'Thank you for your request !',
    intro: [
      'We have received your quote request and will prepare a personalized proposal for your project.',
      'Our trade team will get back to you within 2–3 business days.',
    ],
    steps: [
      {
        title: 'Quote preparation',
        text: 'Our team reviews your project details, products of interest, and shipping requirements.',
      },
      {
        title: 'Quote sent to your inbox',
        text: 'You will receive a detailed quote by email, including pricing, lead times, and delivery options.',
      },
      {
        title: 'Order confirmation',
        text: 'Once you approve the quote, our team will finalise your order and coordinate delivery with you.',
      },
    ],
    contact: { label: 'Questions ? Contact us at', email: 'us.trade@audocph.com' },
    cta: { label: 'Explore the collection', href: '/collections/all' },
  };

  static PRODUCTS = {
    field: 'custom#products_of_interest',
    initial: 2,
    max: 4,
    heading: 'Products of Interest',
    intro: 'Please provide the name, SKU (if known) and quantity of products needed.',
    addLabel: 'Add Additional',
    removeLabel: 'Remove',
    requireFirst: false,
    columns: [
      { key: 'name', label: 'Product Name', required: true, width: 'full' },
      { key: 'sku', label: 'Product SKU' },
      { key: 'quantity', label: 'Quantity', required: true, type: 'number' },
    ],
  };

  static PROJECT = {
    field: 'customer_fields#project_name',
    columns: [
      { key: 'name', label: 'Project Name', width: 'full' },
      { key: 'description', label: 'Project Description', required: true, width: 'full' },
    ],
  };

  static FIELD_NOTES = {
    'custom#shipping_method_requested':
      'White Glove Delivery is encouraged on all large furniture deliveries and required for Plinth Low.',
  };

  static STEP_SUBTITLES = [
    '',
    'Please provide information about your A&D business.',
    'With more information about your project, we can support on your inquiry more quickly and easily.',
  ];

  constructor(options = {}) {
    super({
      name: 'request-quote',
      steps: RequestQuoteForm.STEPS,
      fullWidthFields: RequestQuoteForm.FULL_WIDTH_FIELDS,
      stepSubtitles: RequestQuoteForm.STEP_SUBTITLES,
      uploadHelp: RequestQuoteForm.UPLOAD_HELP,
      startedEvent: 'Started Quote Request',
      completedEvent: 'Completed Quote Request',
      statusProperty: 'quote_request_status',
      fieldNotes: RequestQuoteForm.FIELD_NOTES,
      products: RequestQuoteForm.PRODUCTS,
      fieldGroups: [RequestQuoteForm.PROJECT],
      successContent: RequestQuoteForm.SUCCESS,
      headingAccent: null,
      nextLabel: 'Next step',
      backLabel: 'Back',
      tabsLabel: 'Request a quote steps',
      ...options,
    });
  }

  static boot() {
    const tag = document.getElementById('request-quote-form-js');
    const urlParam = 'open_quote';

    if (!RequestQuoteForm.shouldBoot({ trigger: 'request-quote', urlParam })) return false;

    const formId = (tag && tag.dataset.formId) || RequestQuoteForm.FORM_ID;
    const embedId =
      formId === RequestQuoteForm.FORM_ID ? RequestQuoteForm.EMBED_ID : `app-embed-container-${formId}`;

    const form = new RequestQuoteForm({
      embedId,
      formId,
      stylesUrl: tag ? tag.dataset.styles : null,
      urlParam,
      partialCapture: tag ? tag.dataset.partialCapture === 'true' : false,
      debug: tag ? tag.dataset.debug === 'true' : false,
    });

    if (form.debug || (window.Shopify && window.Shopify.designMode)) {
      window.requestQuoteForm = form;
    }

    return form.init();
  }
}

RequestQuoteForm.boot();
